import { getGetApiChatBotDataListQueryKey, TextProcessConfig, useGetApiChatBotDataList } from "@/API";
import { Button, Group, Loader, Modal, Select, Stack, Switch } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { PropsWithChildren, useEffect } from "react";

export function ChatBotDataIdEditButton(props: { workspaceId: string, value?: string, onChange?: (value: string) => void } & PropsWithChildren) {
    const [opened, { open, close }] = useDisclosure(false);

    const chatBotDataList = useGetApiChatBotDataList({ workspaceId: props.workspaceId ?? "" }, {
        query: {
            queryKey: getGetApiChatBotDataListQueryKey({ workspaceId: props.workspaceId ?? "" }),
            enabled: !!props.workspaceId
        }
    })

    const form = useForm<{
        chatBotDataId: string
    }>({
        initialValues: {
            chatBotDataId: props.value ?? ""
        },

    });
    useEffect(() => {
        if (opened) {
            if (props.value) form.setValues({
                chatBotDataId: props.value ?? ""
            })
            else form.reset()
        }
    }, [opened])

    return <>
        <div onClick={open}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} title="修改連接機器人">
            <form onSubmit={form.onSubmit((values) => {
                props.onChange?.(values.chatBotDataId)
                close()
            })}>
                {
                    chatBotDataList.isFetching ? <Loader /> :
                        (chatBotDataList.data?.data.results?.length ?? 0) > 0 ?
                            <Select
                                label="連接機器人"
                                placeholder="機器人名稱"
                                allowDeselect={true}
                                data={chatBotDataList.data?.data.results?.filter(x => !!x.id).map(x => {
                                    return {
                                        label: `${x.name ?? "unknown"}(${x.id})`,
                                        value: x.id!
                                    }
                                }) ?? []}
                                {...form.getInputProps('chatBotDataId')}
                            /> : <></>
                }
                <Group justify="flex-end" mt="md">
                    <Button type="submit">確認</Button>
                </Group>
            </form>
        </Modal>
    </>
}